(() => {
    "use strict"

    if (document.querySelector('[data-filter]')) {
        const filters = document.querySelectorAll('[data-filter]')
        const items = document.querySelectorAll('[data-item-type]')

        filters.forEach(filter => {
            filter.addEventListener('click', evt => {
                evt.preventDefault()

                const selectedFilter = evt.target.dataset.filter.trim()
                
                items.forEach(item => {
                    if (selectedFilter !== 'all') {
                        if (item.dataset.itemType.trim() !== selectedFilter) {
                            item.classList.remove('active')
                        }
                        else {
                            item.classList.add('active')
                        }
                    }
                    else {
                        item.classList.add('active')
                    }
                })
            })
        })
    }
})()